// Categorías de productos que se venden en unidades enteras (no fraccionables).
export const INTEGER_QUANTITY_CATEGORIES = ['hardware', 'servicios', 'bundles'];

export function isIntegerQuantityCategory(category?: string | null): boolean {
  if (!category) return false;
  return INTEGER_QUANTITY_CATEGORIES.includes(category.toLowerCase());
}

// Redondea a entero la cantidad para categorías de hardware/servicios/bundles,
// preservando los decimales en licencias y telecomunicaciones.
export function roundQuantityForCategory(value: number, category?: string | null): number {
  if (isIntegerQuantityCategory(category)) {
    return Math.round(value);
  }
  return value;
}